// import { format } from "date-fns";

export interface Column {
  id: 'id' | 'titulo' | 'sinopse' | 'recomendação' | 'tópicos' ;
  label: string;
  width?:number|string;
  minWidth?: number|string;
  maxWidth?: number|string;
  align?: 'right' | 'center' | 'left';
  format?: (value: string|number|undefined) => string;
}

export const columns: readonly Column[] = [
  { id: 'id', label: 'ID' , width:'25vw', maxWidth:'25vw', align: 'center'},
  { id: 'titulo', label: 'Título' , width:'25vw', maxWidth:'25vw', align: 'center'},
  { id: 'sinopse', label: 'Sinopse', width:'25vw', maxWidth:'25vw', align: 'center'},
  { id: 'recomendação', label: 'Recomendação', width:'25vw', maxWidth:'25vw', align: 'center'},
  { id: 'tópicos', label: 'Tópicos', width:'25vw', maxWidth:'25vw', align: 'center' },
];